/* ============================================================
   SADOER — interacciones propias (vanilla, sin librerías)
   ============================================================ */
(function () {
  "use strict";

  if (window.__mtSadoerInit) return;
  window.__mtSadoerInit = true;

  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---- Reveal al hacer scroll (un solo observer compartido) ---- */
  function initReveal() {
    var els = document.querySelectorAll(".mt-reveal");
    if (!els.length) return;
    if (reduce || !("IntersectionObserver" in window)) {
      els.forEach(function (el) { el.classList.add("mt-visible"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        var group = el.parentElement ? el.parentElement.querySelectorAll(":scope > .mt-reveal") : [el];
        var idx = Array.prototype.indexOf.call(group, el);
        el.style.setProperty("--mt-delay", (Math.max(idx, 0) * 0.09) + "s");
        el.classList.add("mt-visible");
        io.unobserve(el);
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" });
    els.forEach(function (el) { io.observe(el); });
    // Red de seguridad: nada debe quedar invisible para siempre.
    setTimeout(function () {
      els.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) el.classList.add("mt-visible");
      });
    }, 2600);
  }

  /* ---- Cifras animadas (count-up) ---- */
  function initCount() {
    var nums = document.querySelectorAll(".mt-num[data-to]");
    if (!nums.length) return;
    if (reduce || !("IntersectionObserver" in window)) {
      nums.forEach(function (n) { n.textContent = n.getAttribute("data-to").replace(".", ","); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        animate(e.target);
        io.unobserve(e.target);
      });
    }, { threshold: 0.35, rootMargin: "0px 0px -10% 0px" });
    nums.forEach(function (n) { io.observe(n); });

    function animate(el) {
      var raw = el.getAttribute("data-to");
      var target = parseFloat(raw);
      var decimals = (raw.split(".")[1] || "").length;
      var finalTxt = target.toFixed(decimals).replace(".", ",");
      var dur = 1600, start = null, done = false;
      function step(ts) {
        if (start === null) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = (target * eased).toFixed(decimals).replace(".", ",");
        if (p < 1) requestAnimationFrame(step);
        else done = true;
      }
      requestAnimationFrame(step);
      // Red de seguridad: si rAF no corre (pestaña en segundo plano), fija el valor final.
      setTimeout(function () { if (!done) el.textContent = finalTxt; }, dur + 400);
    }
  }

  /* ---- FAQ acordeón ---- */
  function initFaq() {
    var items = document.querySelectorAll(".mt-faq__item");
    if (!items.length) return;
    items.forEach(function (item) {
      var btn = item.querySelector(".mt-faq__q");
      var ans = item.querySelector(".mt-faq__a");
      if (!btn || !ans) return;
      btn.addEventListener("click", function () {
        var open = item.classList.contains("is-open");
        item.classList.toggle("is-open", !open);
        btn.setAttribute("aria-expanded", String(!open));
      });
    });
  }

  /* ---- Hero: parallax suave (solo transform) ---- */
  function initParallax() {
    var media = document.querySelector(".mt-hero__media");
    if (!media || reduce) return;
    var ticking = false;
    function update() {
      var rect = media.parentElement.getBoundingClientRect();
      var shift = Math.max(Math.min(-rect.top * 0.16, 90), -90);
      media.style.transform = "translate3d(0," + shift.toFixed(1) + "px,0)";
      ticking = false;
    }
    window.addEventListener("scroll", function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  /* ---- Header: fondo al hacer scroll ---- */
  function initHeader() {
    var header = document.querySelector(".section-header") || document.querySelector("header");
    if (!header) return;
    function onScroll() {
      header.classList.toggle("mt-header--scrolled", window.scrollY > 30);
    }
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  /* ---- Galería de producto ---- */
  function initGaleria() {
    var gal = document.querySelector(".mt-gal");
    if (!gal) return;
    var main = gal.querySelector(".mt-gal__main img");
    var thumbs = gal.querySelectorAll(".mt-gal__thumb");
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (t) {
      t.addEventListener("click", function () {
        var full = t.getAttribute("data-full");
        if (!full) return;
        main.src = full;
        thumbs.forEach(function (x) { x.classList.remove("is-active"); });
        t.classList.add("is-active");
      });
    });
  }

  /* ---- Comparador antes / después ---- */
  function initComparador() {
    var nodes = document.querySelectorAll("[data-comparador]");
    if (!nodes.length) return;
    nodes.forEach(function (ba) {
      var handle = ba.querySelector(".mt-ba__handle");
      var start = parseFloat(ba.getAttribute("data-inicio")) || 55;
      var pos = start;
      var dragging = false;

      function set(p, withTransition) {
        pos = Math.max(0, Math.min(100, p));
        ba.classList.toggle("is-dragging", !withTransition);
        ba.style.setProperty("--mt-ba-pos", pos + "%");
        if (handle) handle.setAttribute("aria-valuenow", Math.round(pos));
      }
      function fromEvent(e) {
        var rect = ba.getBoundingClientRect();
        var x = (e.touches ? e.touches[0].clientX : e.clientX) - rect.left;
        set((x / rect.width) * 100, false);
      }
      function down(e) {
        dragging = true;
        ba.classList.add("is-dragging");
        fromEvent(e);
        e.preventDefault();
      }
      function move(e) { if (dragging) fromEvent(e); }
      function up() { dragging = false; }

      ba.addEventListener("pointerdown", down);
      window.addEventListener("pointermove", move, { passive: true });
      window.addEventListener("pointerup", up);
      // respaldo tactil para navegadores sin Pointer Events
      ba.addEventListener("touchstart", down, { passive: false });
      window.addEventListener("touchmove", move, { passive: true });
      window.addEventListener("touchend", up);

      if (handle) {
        handle.addEventListener("keydown", function (e) {
          var step = e.shiftKey ? 10 : 3;
          if (e.key === "ArrowLeft" || e.key === "ArrowDown") { set(pos - step, true); e.preventDefault(); }
          else if (e.key === "ArrowRight" || e.key === "ArrowUp") { set(pos + step, true); e.preventDefault(); }
          else if (e.key === "Home") { set(0, true); e.preventDefault(); }
          else if (e.key === "End") { set(100, true); e.preventDefault(); }
        });
      }

      // Pequeña demostración una sola vez al entrar en pantalla.
      ba.style.setProperty("--mt-ba-pos", start + "%");
      if (!reduce && "IntersectionObserver" in window) {
        var shown = false;
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (!en.isIntersecting || shown) return;
            shown = true;
            ba.classList.remove("is-dragging");
            set(88, true);
            setTimeout(function () { ba.classList.remove("is-dragging"); set(start, true); }, 620);
            io.disconnect();
          });
        }, { threshold: 0.4 });
        io.observe(ba);
      }
    });
  }

  /* ---- Variantes de producto ---- */
  function initVariantes() {
    var root = document.querySelector(".mt-buy[data-variants]");
    if (!root) return;
    var data;
    try { data = JSON.parse(root.getAttribute("data-variants")); } catch (e) { return; }
    var selects = root.querySelectorAll(".mt-buy__opt select");
    var idInput = root.querySelector('input[name="id"]');
    var priceEl = root.querySelector(".mt-buy__price b");
    var compareEl = root.querySelector(".mt-buy__price s");
    var addBtn = root.querySelector(".mt-buy__add");
    var money = root.getAttribute("data-money") || "{{amount}}";
    if (!selects.length) return;

    function fmt(cents) {
      var v = (cents / 100).toLocaleString("es-ES", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      var out = money
        .replace(/\{\{\s*amount\s*\}\}/g, v)
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, v)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(cents / 100)))
        .replace(/\{\{\s*amount_with_space_separator\s*\}\}/g, v)
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, String(Math.round(cents / 100)));
      if (out.indexOf("{{") !== -1 || !out.trim()) out = v + " €";
      return out;
    }
    function update() {
      var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
      var match = data.find(function (v) {
        return v.options.every(function (o, i) { return o === chosen[i]; });
      });
      if (!match) return;
      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.textContent = fmt(match.price);
      if (compareEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          compareEl.textContent = fmt(match.compare_at_price);
          compareEl.style.display = "";
        } else {
          compareEl.style.display = "none";
        }
      }
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available ? addBtn.getAttribute("data-label") : (addBtn.getAttribute("data-sold") || "Agotado");
      }
    }
    selects.forEach(function (s) { s.addEventListener("change", update); });
    update();
  }

  /* ---- Red de seguridad global: si IntersectionObserver o rAF no funcionan
     (p. ej. la pestaña se cargó en segundo plano), asegura que todo el
     contenido en pantalla sea visible y las cifras muestren su valor. ---- */
  function sweep() {
    var vh = window.innerHeight;
    document.querySelectorAll(".mt-reveal:not(.mt-visible)").forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < vh && r.bottom > 0) el.classList.add("mt-visible");
    });
    document.querySelectorAll(".mt-num[data-to]").forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < vh && r.bottom > 0 && el.textContent.trim() === "0") {
        var raw = el.getAttribute("data-to");
        var d = (raw.split(".")[1] || "").length;
        el.textContent = parseFloat(raw).toFixed(d).replace(".", ",");
      }
    });
  }
  var sweepT;
  function sweepSoon() { clearTimeout(sweepT); sweepT = setTimeout(sweep, 120); }

  function boot() {
    initReveal();
    initCount();
    initFaq();
    initParallax();
    initHeader();
    initGaleria();
    initVariantes();
    initComparador();
    window.addEventListener("scroll", sweepSoon, { passive: true });
    window.addEventListener("resize", sweepSoon, { passive: true });
    document.addEventListener("visibilitychange", function () {
      if (!document.hidden) setTimeout(sweep, 60);
    });
    window.addEventListener("load", function () { setTimeout(sweep, 400); });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
